import { render } from "./CertificationItem.vue?vue&type=template&id=deaf5922&scoped=true"
import script from "./CertificationItem.vue?vue&type=script&lang=js"
export * from "./CertificationItem.vue?vue&type=script&lang=js"

import "./CertificationItem.vue?vue&type=style&index=0&id=deaf5922&lang=postcss&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deaf5922"]])

export default __exports__